import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormControlLabel,
  Switch,
  Modal,
  Box,
  Typography,
  Button,
  Divider,
} from "@mui/material";
import moment from 'moment';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import Controls from '../../components/controls/Controls';
import { deleteAlert, getReportLink, runAlert, updateAlert } from "../../config/services/alert";
import { useNavigate } from 'react-router-dom'
import React, { useEffect, useState } from "react";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import toast from 'react-hot-toast'


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 360,
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  borderRadius: '5px',
  boxShadow: 24,
  p: 4,
};


export default function AlertTable({ reportsList, setFlag, flag, itemsPerPage, pageNo }) {
        const [updatedList, setUpdatedList] = useState([])
        const navigate = useNavigate()
        const [open, setOpen] = useState(false);
        const [dataStore, setDataStore] = useState(null)
        const [isPending, setIsPending] = useState(false)
    
    const handleClick = async (report, updatedList) => {
        try {
            if(typeof report?.reportsName[0]==='string') {window.location.reload(); return }
            setIsPending(true)
            const reportsName = report?.reportsName?.map(report => report.reportName);
            const param ={
              ...report,
              reportsName:reportsName,
              manualRun: true
            }
            toast.dismiss()
            toast.loading('Alert run in progress...');
            const reportInfo = await runAlert(param)
            toast.dismiss()
            if(reportInfo?.data?.statusCode === 0) toast.error(reportInfo.data?.error)
            if(reportInfo?.message) {
             toast.success(reportInfo?.message)
              setFlag(!flag)
              // window.location.reload()
            }
            
            setIsPending(false)
        } catch (error) {
            console.log('HandleClick error: ' + error);
        }
    }

    const getReportUrlById = async () => {
      try {
            const updatedReportsList = await Promise.all(reportsList?.map(async report => {
              const alertId = report._id
              let urlList
              if(alertId){ 
                urlList = await getReportLink({alertId});
              }
              const reportids = urlList?.result?.map(obj=>obj.reportId) ?? []
              let newLinkedReport
                const linkedReport = report?.reportsName?.map((obj, i) => {
                  const index = reportids?.indexOf(report?.reportsId[i])
                  if(index!==-1){
                    return{
                    reportName: obj?.reportName ? obj?.reportName:obj,
                    reportUrl: urlList?.result[index]?.reportUrl
                    }
                  }else{
                    return{
                    reportName: obj?.reportName ? obj?.reportName:obj,
                    reportUrl: null
                    }
                  }
              });
                newLinkedReport = linkedReport
              return { 
                ...report, 
                reportsName: newLinkedReport
              };
          }));
          setUpdatedList(updatedReportsList)

      } catch (error) {
          console.log('Error: ' + error);
      }
    }
  
  
    useEffect(() => {
      if(reportsList.length>0)
        getReportUrlById()
      }, [reportsList])


    const handleButtonClick = async (report, type) => {
      if(typeof report?.reportsName[0]==='string') {window.location.reload(); return }
      if(type === 'edit')
      navigate(`/updateAlert/${report?._id}`, { state: { report: report } })
    }

    const handleStatusChange = async (event, report) => {
      try{
        const newCheckedValue = event.target.checked;
        report.status = newCheckedValue
        await updateAlert(report)
        setFlag(!flag)
      }catch(err){
        console.log("Error: ", err)
      }
      
    };

    const handleDelete = async(row) => {
      const _id = row._id
      try{
        await deleteAlert({_id})
        setFlag(!flag)
      }catch(e){
        console.error("Error while deleting", e)
      }
    }
    
    const toastDisplay = () => {
      toast.dismiss()
      toast.error("Operation Pending!")
    }

  return (
    <>
    <TableContainer>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow className="cm_table_head">
            <TableCell>S.No.</TableCell>
            <TableCell>Report Name</TableCell>
            <TableCell>Frequency</TableCell>
            <TableCell>Last Run (Cron)</TableCell>
            <TableCell>Last Run (Manual)</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {updatedList?.length > 0 && updatedList?.map((report, i) => (
            <TableRow key={i}>
                <TableCell>{((pageNo-1)*itemsPerPage)+(i + 1)}</TableCell>
                <TableCell>
                  {report?.reportsName?.map((link, index) => (
                    <React.Fragment key={index}>
                      <a href={link?.reportUrl}>{link?.reportName}</a>
                      <br />
                    </React.Fragment>
                  ))}
                </TableCell>
                <TableCell>{report?.frequency}</TableCell>
                <TableCell> {report?.lastRun ? moment(report?.lastRun).format('YYYY-MM-DD (HH:mm A)') : 'NA'} </TableCell>
                <TableCell> {report?.lastRunSecondary ? moment(report?.lastRunSecondary).format('YYYY-MM-DD (HH:mm A)') : 'NA'} </TableCell>
                <TableCell>
                      <FormControlLabel
                        className="text-plain"
                        control={<Switch checked={report?.status ? report?.status : false}
                        onChange={(event)=>handleStatusChange(event,report)}/>}
                        label="" />
                </TableCell>
                <TableCell>
                    <Controls.ActionButton
                        color="root"
                        onClick={isPending? toastDisplay:(() => handleButtonClick(report, 'edit') )}
                    >
                        <EditOutlinedIcon fontSize="small" />
                    </Controls.ActionButton>
                    <Controls.ActionButton
                        color="root"
                        onClick={isPending? toastDisplay:(e => {setOpen(true); setDataStore(report)})}
                    >
                        <DeleteIcon />
                    </Controls.ActionButton>
                    <Controls.ActionButton
                        color="root"
                        onClick={isPending? toastDisplay:(e => handleClick(report, updatedList))}
                    >
                        <ForwardToInboxIcon />
                    </Controls.ActionButton>
                </TableCell>
            </TableRow>
                    ))}
        </TableBody>
      </Table>
    </TableContainer>

        <Modal
          open={open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2" mb={2}>
              Are you sure you want to delete this alert?
            </Typography>
            <Divider/>
            <Box  mt={2} display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
              <Controls.Button
                  text="Cancel"
                  variant="outlined"
                  onClick={() => setOpen(false)}
                  size='medium'
              />
              <Controls.Button
                  text="Delete"
                  variant="contained"
                  onClick={()=>{handleDelete(dataStore); setOpen(false)}}
                  size='medium'
              />
            </Box>
          </Box>
        </Modal>
    </>
  );
}

